import i18n from '@/i18n';

// Fallback messages in English
const fallbackMessages = {
  api_error_user_bad_login: "Please check your email and password then try again",
  api_error_addresses_invalid: "Enter proper address details",
  api_error_user_bad_data: "Please enter correct details",
  api_error_user_status_request_invalid: "Unable to process the status change request. Please verify the request details and try again.",
  api_error_files_upload_parse: "File upload failed. Please ensure the file is sent as form-data.",
  api_error_license_no_active_subscription: "You do not have an active subscription",
  api_error_invitation_create: "Unable to Invite. Please verify the request details and try again.",
  api_error_user_encryption_not_set: "User has not set up encryption.",
  api_error_user_encryption_save: "Unable to save the encryption.",
  api_error_customer_object_limit: "you have too many of those",
  api_error_customer_object_template: "invalid template",
  api_error_customer_object_missing: "could not find",
  api_error_invitation_response_agent_logged_out: "You must be logged in to respond to an agent invitation",
  api_error_user_bad_county: "Please provide a valid county name, you may have used a country name instead",
  api_error_agent_verify_code_mismatch: "codes did not match",
  api_error_agent_verify_order: "order invalid, the user must begin the process and then the agent verifies"
};

export const getErrorMessage = (errorKey) => {
  const translation = i18n.global.t(`validation.apiErrorMessages.${errorKey}`);
  
  // If translation returns the key path (not found), use fallback
  if (translation === `validation.apiErrorMessages.${errorKey}`) {
    return fallbackMessages[errorKey] || errorKey;
  }
  
  return translation;
};

// For backward compatibility, create a dynamic object that evaluates translations on access
export const errorMessage = new Proxy({}, {
  get(target, prop) {
    const translation = i18n.global.t(`validation.apiErrorMessages.${prop}`);
    
    // If translation returns the key path (not found), use fallback
    if (translation === `validation.apiErrorMessages.${prop}`) {
      return fallbackMessages[prop] || prop;
    }
    
    return translation;
  }
});
